export default "__VITE_ASSET___RjNa$1W__"